<div class="oauth-button-container">
  <p>or</p>
  <dx-button
    width="100%"
    icon="assets/icons/google-logo.svg"
    [text]="'crmContacts.actions.signInGoogle' | translate"
    [stylingMode]="btnStylingMode"
  ></dx-button>
  <dx-button
    width="100%"
    icon="assets/icons/microsoft-logo.svg"
    [text]="'crmContacts.actions.signInMicrosoft' | translate"
    [stylingMode]="btnStylingMode"
  ></dx-button>
</div>
